module.exports = __webpack_public_path__ + "img/xunfei-xinghuo-logo.43ed6a46.png";